










import { Component, Vue } from "vue-property-decorator";
@Component({
  name: 'StatementPreview',
  components: {}
})
export default class StatementPreview extends Vue {
  pdfUrl = "";
  created() {
    const file: any = this.$route.query.file;
    this.pdfUrl = encodeURIComponent(file);
    if (this.$route.query.title) {
      document.title = file;
    }
  }
}
